<template>
  <span class="block" :style="{height: height + 'px'}">
    <slot>{{title}}</slot>
  </span>
</template>

<script>
  export default{
    props:{
      data:{
        type:Array,
        default(){
          return [
          ]
        }
      },
      height:{
        style:Number
      }
    },
    data(){
      return {
        title:''
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .block{
   width: 415px;
   display: inline-block;
   position: relative;
   padding:10px;
   margin-top:5px;
   height: auto;
   overflow: hidden;
   background: rgba(241, 246, 255, 0.8);
   box-shadow: 0px 2px 6px 0px rgba(163, 191, 255, 0.5);
   border-radius: 6px;
   border: 2px solid #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/block.vue